module.exports = __webpack_public_path__ + "img/asado.4e67ca36.jpg";